import React, {Component} from 'react';
import superagent from 'superagent';
import jsonp from 'superagent-jsonp';
import SearchBar from './components/search_bar';
import WikiList from './components/wiki_list';
import _ from 'lodash';
import './App.css';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wikis: []
    };
  }

  wikiSearch(term) {
    const url = `https://en.wikipedia.org/w/api.php?format=json&action=query&origin=*&generator=search&gsrnamespace=0&gsrlimit=10&prop=pageimages|extracts&pilimit=max&exintro&explaintext&exsentences=1&exlimit=max&gsrsearch=${encodeURIComponent(term)}`;
    superagent.get(url).use(jsonp({
      timeout: 3000
    })).end((err, res) => {
      if (res !== null && res.body.query !== undefined) {
        const pages = res.body.query.pages;
        const wikis = [];
        for (let key in pages) {
          wikis.push(pages[key]);
        }
        this.setState({wikis});
      }
    });
  }

  render() {
    const wikiSearch = _.debounce((term) => {
      this.wikiSearch(term)
    }, 300);

    return (
      <div className="App">
        <div className="container">
          <h1 className="logo">
            <a href="https://en.wikipedia.org/wiki/Special:Random" target="_blank" rel="noopener noreferrer"
               title="I feel lucky!">
              <i className="icon ion-social-wordpress-outline"></i>
            </a>
            ikipedia
          </h1>
          <SearchBar onSearchTermChange={wikiSearch}/>
          <WikiList wikis={this.state.wikis}/>
        </div>

        <div className="footer">by <a href="https://github.com/devjam1" target="_blank" rel="noopener noreferrer">devjam</a></div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js